import { createSelector } from "reselect";

export const siteGroupsSelector = createSelector(
    state => state.services.siteGroup,
    state => state
);